export const migrations = {
  0: state => {
    return state;
  },
};

export const version = 0;
